import { lazy } from "react"
import { ProtectedHubLayoutRoute } from "components/layouts/HubLayout"
import { departmentPath } from "./Paths"

const Departments = lazy(() => import("./Departments"))

const Routes = () => <ProtectedHubLayoutRoute exact path={departmentPath} Component={Departments} />

export default Routes
